export default "__VITE_ASSET__DYk6fv0i__"